<!--<div class="w-100 font-16">
    <div class="row d-flex">
        <div class="col-3" *ngIf="appointment && appointment.patientName!= null">
            <strong style="font-size:13px">Patient Name:</strong>&nbsp;
            <span [textContent]="appointment.patientName"></span>
        </div>
        <div class="col-3" *ngIf="appointment && appointment.umrNo!= null">
            &nbsp;
            <strong style="font-size:13px">UMR No:</strong>
            <span [textContent]="appointment.umrNo"></span>
        </div>
    </div>
    <div class="col-3" *ngIf="appointment && appointment.roomName!= null">
        <strong style="font-size:17px">Room Name:</strong>&nbsp;
        <span [textContent]="appointment.roomName"></span>
    </div>
    <div class="row d-flex font-weight-medium align-items-baseline mt-1">
        <div class="col-3" *ngIf="husbandName != null">
            <strong style="font-size:13px">Husband Name:</strong>&nbsp;
            <span [textContent]="husbandName"></span>
        </div>
        <div class="col-3" *ngIf="visit != null">
            <strong style="font-size:13px">Visit No:</strong>&nbsp;
            <span [textContent]="visit"></span>
        </div>
    </div>
    <div *ngIf="specialFeature && specialFeature.specialFeature != null" class="d-flex font-weight-medium w-100">
        <strong class="white-space-nowrap" style="color: darkblue;">Special Features:</strong>
        <span class="break-all" [textContent]="specialFeature.specialFeature"></span>
    </div>
</div>-->
<div class="w-100 font-16">
    <div class="row ">
        <div class="col-3">
            <i class="mdi mdi-account text-primary mr-1"></i><strong style="font-size:17px">Patient Name :</strong>&nbsp;
            <span *ngIf="appointment && appointment.patientName" [textContent]="appointment.patientName"></span>
        </div>
        <div class="col-3">
            <i class="mdi  text-primary mr-1"></i><strong style="font-size:17px">UMR No :</strong>&nbsp;
            <span *ngIf="appointment && appointment.umrNo" [textContent]="appointment.umrNo"></span>
        </div>
    </div>
    <!-- <div class="row d-flex font-weight-medium align-items-baseline mt-1">
         <div class="col-3">
             <strong style="font-size:17px">Visit No:</strong>&nbsp;
             <span   *ngIf="visit != null" [textContent]="visitNo"> </span>
         </div>
     </div>-->
    <div *ngIf="specialFeature && specialFeature.specialFeature" class="d-flex font-weight-medium w-100">
        <strong class="white-space-nowrap" style="color: darkblue;">Special Features : </strong>&nbsp;
        <span class="break-all" *ngIf="specialFeature && specialFeature.specialFeature" [textContent]="specialFeature.specialFeature"></span>

    </div>

</div>